module.exports = __webpack_public_path__ + "img/coupon_detail_5@2x.b8ee78f3.svg";